<script setup>
import AudienceTable from '@frontJs/components/tables/projectManagement/sma/AudienceTable.vue';
import TenantReportAudienceTable from '@frontJs/components/tables/projectManagement/sma/tenantReports/AudienceTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Audiences - SMA - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SMA - Audiences
    </PageTitle>

    <AudienceTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(TenantReportAudienceTable),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(TenantReportAudienceTable, { type: 'e-commerce' }),
            },
            showcase: {
                title: 'Showcase',
                content: h(TenantReportAudienceTable, { type: 'showcase' }),
            },
        }"
    />
</template>
